import { css } from '@emotion/core'
import styled from '@themes/theme'
import { DarkSkeletonStyle, StateListStyle } from '@views/Home/index.style'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'
import { ButtonStyles } from '@styles/button.style'

export const UserInfoBtnStyle = css`
  height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid rgba(64, 80, 96, .2);
  svg {
    margin-right: -4px;
    path {
      &.fill-1, &.fill-3 {
        fill: #99A7B7;
      }
      &.fill-2 {
        fill: #405060;
      }
    }
  }
`
const ProfileSize = '85px'
export const UserDetailPopup = styled.div`
  height: 100%;
  .profile-bg {
    position: relative;
    width: 100%;
    height: auto;
    aspect-ratio: 3 / 1;
    .bg-img {
      width: 100%;
      height: auto;
      opacity: .45;
      &.skeleton {
        ${DarkSkeletonStyle};
        background: #2A323E66 !important;
        display: block;
        aspect-ratio: 3 / 1;
        border-radius: 0;
        &::before {
          background-size: 200%;
          background-image: linear-gradient(to left, rgba(49, 57, 71, 0),rgba(49, 57, 71, .2), rgba(49, 57, 71, 1), rgba(49, 57, 71, .2), rgba(49, 57, 71, 0));
        }
      }
    }
    .shadow {
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 50%;
      background: linear-gradient(to top, rgba(28, 32, 43, 1), rgba(28, 32, 43, 0));
    }
  }
  .profile-header {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 27px;
    margin-top: -9vmin;
    padding: 0 21px;
    &.pc {
      margin-top: -10%;
    }
    &--info {
      display: flex;
      width: 100%;
      align-items: center;
      .skeleton {
        .gray-skeleton {
          ${DarkSkeletonStyle};
        }
      }
      .profile {
        position: relative;
        margin-right: 15px;
        .profile-img-wrap {
          ${ProfileImgWrapStyle};
          width: ${ProfileSize};
          height: ${ProfileSize};
        }
      }
      .nickname {
        margin-bottom: 2px;
        font-size: ${props => props.theme.font.largeNum};
        color: ${props => props.theme.color.themeTxt};
        .mark {
          position: relative;
          bottom: 2px;
          left: initial;
          margin-left: 4px;
        }
      }
      .user-title {
        &--icon {
          width: 16px;
          height: 16px;
          margin-right: 3px;
        }
      }
    }
    .btn-wrap {
      width: 100% ;
      margin-top: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .send-message-btn {
        flex: 1;
      }
    }
  }
  .user-pick-warp {
    padding: 0 18px;
    margin-bottom: 30px;
    .tit {
      margin-bottom: 6px;
      padding-left: 8px;
      font-size: ${props => props.theme.font.title};
      color: ${props => props.theme.color.modalSubBg};
    }
  }
  .monthly-today-pick {
    margin-bottom: 10px;
    padding: 0 8px;
    font-size: ${props => props.theme.font.largeNum};
    .month {
      display: inline-block;
      transform: translateY(-2px);
      width: auto;
      height: 18px;
      padding: 0 5px;
      margin-right: 5px;
      font-size: 13px;
      color: ${props => props.theme.color.mainBg};
      background: linear-gradient(45deg, #F0DAB1, #D69053);
      box-shadow: inset 0.3px 0.3px 0 #FFFCEC;
      border-radius: 4px;
      vertical-align: middle;
    }
    .today-txt-img {
      transform: translateY(-2px);
      width: auto;
      height: 17px;
      margin-right: 4px;
    }
  }
  .hit-state-table {
    padding: 36px 21px 18px;
    background: ${props => props.theme.color.subColor2};
    border-radius: 18px;
    border: 1px solid rgba(64, 80, 96, .5);
    .table-wrap {
      position: relative;
      width: 90%;
      height: 38px;
      margin: 0 auto 30px;
    }
    .table-box {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: flex-start;
      gap: 10.8%;
      width: 100%;
      height: inherit;
      border-top: 1px solid rgba(80, 96, 112, .8);
      border-bottom: 1px solid rgba(80, 96, 112, .8);
      .table-line {
        width: 1px;
        height: 100%;
        border-left: 1px dashed rgba(80, 96, 112, .8);
        &:first-of-type, &:last-of-type {
          border-left: 1px solid  rgba(80, 96, 112, .8);
        }
      }
    }
    .table {
      display: flex;
      flex-flow: row-reverse;
      justify-content: flex-end;
      gap: 10.8%;
      width: 100%;
      height: inherit;
      &--item {
        display: inline-flex;
        flex-flow: column;
        width: 1px;
        .under-over-arrow-icon {
          position: absolute;
          width: 10px;
          transform: translate(-5px, -15px) rotate(180deg);
          path {
            fill: ${props => props.theme.color.themeTxt};
          }
        }
        .result {
          position: relative;
          width: 16px;
          height: 16px;
          img {
            width: auto;
            height: inherit;
          }
          .circle {
            position: absolute;
            top: -6px;
            right: -10px;
            width: 20px;
            height: 20px;
            border: 3px solid ${props => props.theme.color.subColor2};
            border-radius: 50%;
            transform: scale(0.5);
          }
        }
        &.success {
          .result {
            transform: translate(-8px, -8px);
            .circle {
              background: ${props => props.theme.color.secondaryBg};
            }
          }
        }
        &.fail {
          .under-over-arrow-icon {
            transform: translate(-5px, 20px) rotate(0);
          }
          justify-content: flex-end;
          .result {
            transform: translate(-8px, 8px);
            .circle {
              background: ${props => props.theme.color.gray};
            }
          }
        }
        &.cancel {
          justify-content: flex-end;
          .result {
            transform: translate(-8px, 8px);
            .circle {
              background: ${props => props.theme.color.purple};
            }
          }
        }
      }
    }
    .sub-info {
      float: left;
      height: 32px;
      padding: 0 16px;
      line-height: 31px;
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.modalSubBg2};
      text-align: center;
      background: ${props => props.theme.color.mainBg};
      border-radius: 50px;
      box-shadow: inset 3px 3px 3px rgba(24, 27, 36, 0.3), 1px 1px 2px rgba(80, 96, 112, .3);
      .hit-state-success-count {
        display: inline-block;
        transform: translateY(1px);
        margin-left: 4px;
        .recent-hit-rate {
          margin: 0;
        }
      }
    }
    .state-list {
      ${StateListStyle};
      float: right;
      transform: translateY(10px);
      padding-right: 5px;
      &--item {
        // font-size: ${props => props.theme.font.small};
        color: ${props => props.theme.color.btn};
      }
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
`
export const BlockBtn = styled.button`
  ${ButtonStyles};
  background: ${props => props.theme.color.TP};
  width: 20px;
  height: 20px;
  position: absolute;
  top: 12px;
  right: 10px;
  .extra-btn {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    filter: invert(1) brightness(1) contrast(8);
  }
`